/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallerynext1Inputs */

const en_gallerynext1 = /** @type {(inputs: Gallerynext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next image`)
};

const de_gallerynext1 = /** @type {(inputs: Gallerynext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Bild`)
};

/**
* | output |
* | --- |
* | "Next image" |
*
* @param {Gallerynext1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const gallerynext1 = /** @type {((inputs?: Gallerynext1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallerynext1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallerynext1(inputs)
	return de_gallerynext1(inputs)
});
export { gallerynext1 as "galleryNext" }